import styled from 'styled-components';
import { getColor, Theme } from 'styles/theme';
import { font } from 'styles/globals';
import { getIcon } from 'styles/icons';

export const Wrapper = styled.div<{ theme: Theme }>`
  width: 100%;
  position: relative;
  
  .close-icon {
    position: absolute;
    right: 5px;
    top: 11px;
    width: 16px;
    height: 16px;

    ${getIcon('svg-states')};

    &::before {
    margin: auto;
      ${getIcon('close-icon', { height: 12, width: 11 })};
    }
  }
`;

export const SearchInput = styled.input<{ theme: Theme }>`
  display: flex;
  align-items: flex-start;
  flex-shrink: 0;
  border: none;
  width: 100%;
  padding: 6px;
  border-bottom: 1px solid ${getColor('borderTertiary')};
  font-family: ${font.graphikCond};
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.5px;
  text-align: left;
  color: ${getColor('textPrimary')};

  &.search-icon {
    background: transparent url("/icons/MagnifyingGlass.svg") no-repeat 8px center;
    padding-left: 31px;
    flex-shrink: 1;

    border-bottom: 1px solid ${getColor('borderPrimary')};
  }

  &::placeholder {
    color: ${getColor('textSecondary')};
  }

  &:hover {
    border-bottom: 1px solid ${getColor('borderAccentPrimary')};
  }

  &:focus {
    outline: none;
    border-bottom: 1px solid ${getColor('borderAccentPrimary')};
  }

  &[value=""]  ~ .close-icon {
    display: none;
  } 

  &::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }

  &:not(:placeholder-shown) {
    border-bottom: 1px solid ${getColor('borderBlack')};
  }
`;

export default SearchInput;
